import React from "react";
import AssessmentReviewTable from "./assessment-review-table";

const AssessmentReview = () => {

  return (
    <div>
      <AssessmentReviewTable />
    </div>
  );
};

export default AssessmentReview;
